/**
 * Created by User on 2019/8/28.
 */
import Vue from 'vue'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
